import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Tools from "../../components/tools/tools";
import AdDuplicator from "../../components/tools/ad-duplicator";
import WebsiteCreationLogs from "../../components/tools/website-creation-logs";

const ToolsPage = () => {
  return (
    <>
      <Routes>
        <Route element={<Tools />}>
          <Route index path="fb-duplicator" element={<AdDuplicator />} />
          <Route
            path="website-creation-logs"
            element={<WebsiteCreationLogs />}
          />
          <Route path="*" element={<Navigate to="fb-duplicator" />} />
        </Route>
      </Routes>
      <Outlet />
    </>
  );
};
export default ToolsPage;
